import type { Article } from './types';

export const articles: Article[] = [
  {
    slug: 'allchinabuy-spreadsheet',
    category: 'spreadsheet',
    date: '2026-08-20',
    icon: 'ri-table-line',
    image: 'https://readdy.ai/api/search-image?query=A%20clean%20digital%20spreadsheet%20on%20a%20laptop%20screen%20with%20tidy%20columns%20and%20rows%20of%20product%20thumbnails%20links%20and%20prices%2C%20a%20cup%20of%20coffee%20and%20a%20plant%20beside%20the%20laptop%20on%20a%20white%20desk%2C%20bright%20modern%20workspace%2C%20high%20detail%2C%20professional%20organized%20aesthetic&width=800&height=500&seq=art-spreadsheet&orientation=landscape&nocache=true',
    related: ['allchinabuy-review', 'allchinabuy-shipping-cost', 'allchinabuy-qc', 'allchinabuy-buying-guide'],
  },
  {
    slug: 'allchinabuy-review',
    category: 'review',
    date: '2026-08-19',
    icon: 'ri-star-line',
    image: 'https://readdy.ai/api/search-image?query=Five%20golden%20star%20rating%20icons%20lined%20up%20over%20a%20soft%20blush%20pink%20background%20with%20subtle%20confetti%2C%20cheerful%20trustworthy%20review%20concept%2C%20clean%20minimal%20flat%20lay%2C%20bright%20airy%20lighting%2C%20high%20detail%2C%20positive%20modern%20aesthetic&width=800&height=500&seq=art-review&orientation=landscape&nocache=true',
    related: ['allchinabuy-legit', 'allchinabuy-spreadsheet', 'allchinabuy-coupon', 'allchinabuy-comparison'],
  },
  {
    slug: 'allchinabuy-shipping-cost',
    category: 'shipping',
    date: '2026-08-18',
    icon: 'ri-price-tag-3-line',
    image: 'https://readdy.ai/api/search-image?query=A%20cardboard%20parcel%20box%20beside%20a%20calculator%20and%20a%20notepad%20with%20cost%20calculations%20on%20a%20mint%20green%20desk%2C%20budgeting%20for%20shipping%20concept%2C%20clean%20minimal%20still%20life%2C%20bright%20natural%20light%2C%20high%20detail%2C%20fresh%20organized%20aesthetic&width=800&height=500&seq=art-shipping-cost&orientation=landscape&nocache=true',
    related: ['allchinabuy-shipping', 'allchinabuy-warehouse', 'allchinabuy-spreadsheet', 'allchinabuy-shipping-methods'],
  },
  {
    slug: 'allchinabuy-shipping',
    category: 'shipping',
    date: '2026-08-17',
    icon: 'ri-ship-line',
    image: 'https://readdy.ai/api/search-image?query=Several%20neatly%20stacked%20kraft%20cardboard%20parcels%20with%20brown%20tape%20and%20a%20printed%20shipping%20label%20on%20a%20warm%20oak%20table%2C%20warm%20side%20lighting%2C%20clean%20logistics%20product%20photo%2C%20high%20detail%2C%20tidy%20and%20organized%20aesthetic&width=800&height=500&seq=art-shipping&orientation=landscape&nocache=true',
    related: ['allchinabuy-shipping-cost', 'allchinabuy-warehouse', 'allchinabuy-spreadsheet', 'allchinabuy-shipping-time'],
  },
  {
    slug: 'allchinabuy-coupon',
    category: 'coupon',
    date: '2026-08-16',
    icon: 'ri-coupon-3-line',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20discount%20coupon%20tickets%20with%20perforated%20edges%20and%20a%20pair%20of%20scissors%20on%20a%20soft%20lavender%20background%2C%20playful%20savings%20concept%2C%20minimal%20flat%20lay%2C%20bright%20cheerful%20lighting%2C%20high%20detail%2C%20clean%20modern%20aesthetic&width=800&height=500&seq=art-coupon&orientation=landscape&nocache=true',
    related: ['allchinabuy-spreadsheet', 'allchinabuy-shipping-cost', 'allchinabuy-review', 'allchinabuy-discount-code'],
  },
  {
    slug: 'allchinabuy-warehouse',
    category: 'warehouse',
    date: '2026-08-15',
    icon: 'ri-archive-line',
    image: 'https://readdy.ai/api/search-image?query=Neatly%20organized%20metal%20warehouse%20shelves%20with%20labeled%20cardboard%20storage%20boxes%20and%20a%20soft%20warm%20light%20from%20above%2C%20clean%20industrial%20logistics%20interior%2C%20high%20detail%2C%20orderly%20and%20modern%20aesthetic&width=800&height=500&seq=art-warehouse&orientation=landscape&nocache=true',
    related: ['allchinabuy-shipping', 'allchinabuy-qc', 'allchinabuy-spreadsheet', 'allchinabuy-shipping-cost'],
  },
  {
    slug: 'allchinabuy-legit',
    category: 'trust',
    date: '2026-08-14',
    icon: 'ri-shield-check-line',
    image: 'https://readdy.ai/api/search-image?query=A%20green%20shield%20with%20a%20white%20checkmark%20icon%20floating%20over%20a%20soft%20warm%20cream%20background%20with%20soft%20light%20rays%2C%20safety%20and%20trust%20concept%2C%20clean%20minimal%203d%20render%2C%20high%20detail%2C%20reassuring%20modern%20aesthetic&width=800&height=500&seq=art-legit&orientation=landscape&nocache=true',
    related: ['allchinabuy-review', 'allchinabuy-spreadsheet', 'allchinabuy-qc', 'allchinabuy-safety'],
  },
  {
    slug: 'allchinabuy-qc',
    category: 'qc',
    date: '2026-08-13',
    icon: 'ri-camera-lens-line',
    image: 'https://readdy.ai/api/search-image?query=A%20close%20up%20of%20a%20hand%20holding%20a%20magnifying%20glass%20over%20a%20folded%20garment%20inspecting%20the%20stitching%2C%20quality%20control%20concept%2C%20warm%20studio%20lighting%2C%20shallow%20depth%20of%20field%2C%20high%20detail%2C%20meticulous%20focused%20aesthetic&width=800&height=500&seq=art-qc&orientation=landscape&nocache=true',
    related: ['allchinabuy-warehouse', 'allchinabuy-legit', 'allchinabuy-spreadsheet', 'allchinabuy-sellers'],
  },
  {
    slug: 'allchinabuy-alternatives',
    category: 'alternatives',
    date: '2026-08-23',
    icon: 'ri-shuffle-line',
    image: 'https://readdy.ai/api/search-image?query=Three%20separate%20glowing%20doorways%20side%20by%20side%20on%20a%20soft%20neutral%20background%20representing%20multiple%20options%20and%20choices%2C%20clean%20minimal%20concept%20art%2C%20soft%20gradient%20light%2C%20high%20detail%2C%20balanced%20modern%20aesthetic&width=800&height=500&seq=art-alternatives&orientation=landscape',
    related: ['allchinabuy-comparison', 'allchinabuy-review', 'allchinabuy-spreadsheet'],
  },
  {
    slug: 'allchinabuy-comparison',
    category: 'comparison',
    date: '2026-08-22',
    icon: 'ri-scales-3-line',
    image: 'https://readdy.ai/api/search-image?query=Two%20balanced%20columns%20of%20product%20cards%20being%20compared%20side%20by%20side%20on%20a%20light%20grey%20surface%20with%20a%20scale%20icon%20between%20them%2C%20comparison%20concept%2C%20clean%20minimal%20flat%20lay%2C%20bright%20airy%20light%2C%20high%20detail%2C%20modern%20analytical%20aesthetic&width=800&height=500&seq=art-comparison&orientation=landscape',
    related: ['allchinabuy-alternatives', 'allchinabuy-review', 'allchinabuy-shipping-cost'],
  },
  {
    slug: 'allchinabuy-discount-code',
    category: 'coupon',
    date: '2026-08-21',
    icon: 'ri-ticket-2-line',
    image: 'https://readdy.ai/api/search-image?query=A%20smartphone%20screen%20showing%20a%20promo%20discount%20code%20input%20field%20with%20a%20shopping%20bag%20beside%20it%20on%20a%20soft%20coral%20background%2C%20online%20savings%20concept%2C%20clean%20minimal%20product%20photo%2C%20bright%20light%2C%20high%20detail%2C%20modern%20retail%20aesthetic&width=800&height=500&seq=art-discount-code&orientation=landscape',
    related: ['allchinabuy-coupon', 'allchinabuy-spreadsheet', 'allchinabuy-shipping-cost'],
  },
  {
    slug: 'allchinabuy-buying-guide',
    category: 'guide',
    date: '2026-08-21',
    icon: 'ri-shopping-cart-2-line',
    image: 'https://readdy.ai/api/search-image?query=A%20wooden%20shopping%20cart%20with%20a%20small%20gift%20box%20and%20a%20step%20by%20step%20checklist%20notepad%20on%20a%20warm%20beige%20table%2C%20beginner%20shopping%20guide%20concept%2C%20clean%20minimal%20still%20life%2C%20soft%20natural%20light%2C%20high%20detail%2C%20inviting%20helpful%20aesthetic&width=800&height=500&seq=art-buying-guide&orientation=landscape',
    related: ['allchinabuy-spreadsheet', 'allchinabuy-tutorial', 'allchinabuy-review'],
  },
  {
    slug: 'allchinabuy-sellers',
    category: 'sellers',
    date: '2026-08-20',
    icon: 'ri-store-2-line',
    image: 'https://readdy.ai/api/search-image?query=A%20charming%20small%20storefront%20facade%20with%20an%20awning%20and%20a%20hanging%20sign%20on%20a%20quiet%20sunny%20street%2C%20warm%20inviting%20colors%2C%20clean%20illustration%20style%20product%20scene%2C%20high%20detail%2C%20friendly%20trustworthy%20aesthetic&width=800&height=500&seq=art-sellers&orientation=landscape',
    related: ['allchinabuy-review', 'allchinabuy-legit', 'allchinabuy-products'],
  },
  {
    slug: 'allchinabuy-products',
    category: 'products',
    date: '2026-08-19',
    icon: 'ri-search-eye-line',
    image: 'https://readdy.ai/api/search-image?query=A%20neat%20grid%20of%20assorted%20product%20photos%20including%20sneakers%20a%20hoodie%20a%20cap%20and%20a%20watch%20arranged%20on%20a%20white%20gallery%20wall%2C%20product%20research%20concept%2C%20clean%20minimal%20flat%20lay%2C%20bright%20even%20light%2C%20high%20detail%2C%20modern%20editorial%20aesthetic&width=800&height=500&seq=art-products&orientation=landscape',
    related: ['allchinabuy-spreadsheet', 'allchinabuy-sellers', 'allchinabuy-buying-guide'],
  },
  {
    slug: 'allchinabuy-safety',
    category: 'trust',
    date: '2026-08-18',
    icon: 'ri-lock-line',
    image: 'https://readdy.ai/api/search-image?query=A%20golden%20padlock%20with%20a%20key%20resting%20on%20a%20soft%20sage%20green%20background%20with%20gentle%20light%2C%20online%20safety%20and%20security%20concept%2C%20clean%20minimal%20still%20life%2C%20high%20detail%2C%20calm%20reassuring%20aesthetic&width=800&height=500&seq=art-safety&orientation=landscape',
    related: ['allchinabuy-legit', 'allchinabuy-review', 'allchinabuy-sellers'],
  },
  {
    slug: 'allchinabuy-tutorial',
    category: 'guide',
    date: '2026-08-17',
    icon: 'ri-graduation-cap-line',
    image: 'https://readdy.ai/api/search-image?query=An%20open%20notebook%20with%20numbered%20step%20by%20step%20instructions%20and%20a%20laptop%20showing%20a%20video%20tutorial%20on%20a%20light%20wooden%20desk%2C%20learning%20concept%2C%20clean%20minimal%20workspace%2C%20soft%20daylight%2C%20high%20detail%2C%20helpful%20modern%20aesthetic&width=800&height=500&seq=art-tutorial&orientation=landscape',
    related: ['allchinabuy-buying-guide', 'allchinabuy-spreadsheet', 'allchinabuy-shipping'],
  },
  {
    slug: 'allchinabuy-shipping-time',
    category: 'shipping',
    date: '2026-08-16',
    icon: 'ri-time-line',
    image: 'https://readdy.ai/api/search-image?query=A%20small%20wall%20clock%20beside%20a%20wrapped%20parcel%20box%20on%20a%20soft%20cream%20surface%20with%20soft%20shadows%2C%20delivery%20time%20concept%2C%20clean%20minimal%20still%20life%2C%20warm%20natural%20light%2C%20high%20detail%2C%20calm%20modern%20aesthetic&width=800&height=500&seq=art-shipping-time&orientation=landscape',
    related: ['allchinabuy-shipping', 'allchinabuy-shipping-cost', 'allchinabuy-shipping-methods'],
  },
  {
    slug: 'allchinabuy-shipping-methods',
    category: 'shipping',
    date: '2026-08-15',
    icon: 'ri-plane-line',
    image: 'https://readdy.ai/api/search-image?query=A%20parcel%20box%20with%20miniature%20toy%20airplane%20truck%20and%20cargo%20ship%20arranged%20around%20it%20on%20a%20light%20blue%20grey%20surface%2C%20shipping%20methods%20concept%2C%20clean%20minimal%20flat%20lay%2C%20bright%20soft%20light%2C%20high%20detail%2C%20playful%20organized%20aesthetic&width=800&height=500&seq=art-shipping-methods&orientation=landscape',
    related: ['allchinabuy-shipping-time', 'allchinabuy-shipping', 'allchinabuy-shipping-cost'],
  },
];

export const getArticle = (slug: string): Article | undefined =>
  articles.find((a) => a.slug === slug);

export const articleById = (slug: string): Article | undefined =>
  articles.find((a) => a.slug === slug);